var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "store-menu" },
    [
      _c(
        "div",
        { staticClass: "store-wrap" },
        [
          _vm.announcement
            ? _c("div", { staticClass: "store-notice" }, [
                _c(
                  "div",
                  { staticClass: "store-notice-title" },
                  [
                    _c("marquee", [
                      _c("span", [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.announcement) +
                            "\n          "
                        )
                      ])
                    ])
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "store-notice-hover am-padding-horizontal-xs"
                  },
                  [
                    _c("div", { staticClass: "store-notice-title" }, [
                      _vm._v("门店公告")
                    ]),
                    _c("div", { staticClass: "store-notice-content" }, [
                      _c("p", [_vm._v(_vm._s(_vm.announcement))])
                    ])
                  ]
                )
              ])
            : _vm._e(),
          _c(
            "Card",
            {
              attrs: {
                bordered: false,
                "dis-hover": "",
                headerStyle: { background: "#d4d5d5" }
              }
            },
            [
              _c(
                "h2",
                { attrs: { slot: "title" }, slot: "title" },
                [
                  _c("cc-input", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.canSearch,
                        expression: "canSearch"
                      }
                    ],
                    staticClass: "store-search-wrap",
                    attrs: {
                      value: _vm.keywords,
                      styleObj: {
                        maxWidth: "300px",
                        minWidth: "100px",
                        width: "100%"
                      },
                      placeholder: "请输入餐品名称",
                      title: "搜索餐品：",
                      inputlistdata: _vm.searchFoodData,
                      showinputlist: true
                    },
                    on: {
                      select: _vm.checkSearchProduct,
                      input: _vm.searchProduct,
                      blur: _vm.clearSearchData
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "itemText",
                        fn: function(props) {
                          return [
                            !props.item.typeName
                              ? _c("span", [
                                  _vm._v(_vm._s(props.item.productName))
                                ])
                              : _c("span", [
                                  _vm._v(
                                    "[" +
                                      _vm._s(props.item.typeName) +
                                      "] " +
                                      _vm._s(props.item.productName)
                                  )
                                ])
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _c("div", { staticClass: "store-category" }, [
                _c(
                  "ul",
                  { staticClass: "category-list scroll" },
                  _vm._l(_vm.category, function(item, index) {
                    return _c(
                      "li",
                      {
                        key: index,
                        staticClass: "category-item",
                        class: {
                          "category-item-active":
                            (!item.uid && _vm.smallUid === _vm.categoryUid) ||
                            (item.uid &&
                              (item.uid === _vm.categoryUid ||
                                item.uid === _vm.smallUid))
                        },
                        on: {
                          click: function($event) {
                            return _vm.checkCategory(item)
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "category-text am-text-center am-text-truncate",
                            attrs: { title: _vm._f("trim")(item.name) }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm._f("trim")(item.name)) +
                                "\n            "
                            )
                          ]
                        )
                      ]
                    )
                  }),
                  0
                )
              ]),
              _c(
                "div",
                { staticClass: "store-product am-margin-vertical-sm scroll" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "product-list show",
                      class: { disabled: !_vm.isAddCart }
                    },
                    _vm._l(_vm.productList, function(item, index) {
                      return _c(
                        "Poptip",
                        {
                          key: index,
                          attrs: {
                            trigger: "hover",
                            placement: "top",
                            padding: "3px 5px"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: { color: "#000" },
                              attrs: { slot: "content" },
                              slot: "content"
                            },
                            [
                              _vm._v(
                                "\n              温馨提示：该餐品已选" +
                                  _vm._s(item.num || 0) +
                                  "份\n            "
                              )
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "product-item",
                              class: { disabled: item.disabled },
                              on: {
                                click: function($event) {
                                  return _vm.addProduct(item)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "product-trait am-text-truncate"
                                },
                                [_vm._v(_vm._s(_vm._f("productTrait")(item)))]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "product-type am-text-right am-text-truncate"
                                },
                                [_vm._v(_vm._s(item.typeText))]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "product-text",
                                  attrs: { title: _vm._f("trim")(item.name) }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm._f("trim")(item.name)) +
                                      "\n              "
                                  )
                                ]
                              ),
                              item.disabled
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "product-close am-text-center"
                                    },
                                    [_vm._v(_vm._s(item.warnText))]
                                  )
                                : item.maxNum > 0
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "product-inventory am-text-center"
                                    },
                                    [
                                      _vm._v(
                                        "\n                剩余" +
                                          _vm._s(item.stockNum - item.num) +
                                          "份\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ]
                      )
                    }),
                    1
                  )
                ]
              )
            ]
          )
        ],
        1
      ),
      _c("cc-loading-box", {
        staticClass: "loading-box",
        attrs: { isLoading: _vm.loading }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5748ac7a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5748ac7a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/pages/order/StoreMenu/StoreMenu.vue
// module id = U0zK
// module chunks = 0